<template>
    <div>
        <HeaderCard imageLogo="imageLogo" />
        <!-- Badan Usaha UI -->
        <panel class="panel panel-dark mb-0">
            <div v-if="role == 'Badan Usaha'">
                <div v-if="user.npbu_id == null || helper.daftar">
                    <MainContainer />
                </div>
                <div v-else-if="user.npbu_id !== null && helper.verify">
                    
                    <div v-if="helper.detail">
                        <b-table-simple outlined bordered small responsive class="mb-0">
                            <b-tbody>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td class="text-center align-middle">
                                                        <h5 class="font-weight-bold m-0">
                                                            PROFIL BADAN USAHA<br>
                                                            PENGELOLA KEKAYAAN DAERAH YANG DIPISAHKAN
                                                        </h5>
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <!--  -->
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td colspan="2" class="font-weight-bold">
                                                        <u>IDENTITAS BADAN USAHA</u>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        NPBUD
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.no_pokok }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Nama Badan Usaha
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        <div v-if="helper.detail">
                                                            <span v-if="helper.detail.bentuk_badan">
                                                                {{
                                                                    helper.detail.bentuk_badan.kode
                                                                }}
                                                            </span>
                                                            {{ helper.detail.nama }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        NIB
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.no_induk }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Alamat
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail">
                                                            <div>
                                                                {{ helper.detail.alamat }}
                                                            </div>
                                                            <div
                                                                v-if="
                                                                    helper.detail.wilayah_kelurahan
                                                                "
                                                            >
                                                                <div>
                                                                    Kel.
                                                                    {{
                                                                        helper.detail
                                                                            .wilayah_kelurahan.nama
                                                                    }}
                                                                </div>
                                                                <div>
                                                                    Kec.
                                                                    {{
                                                                        helper.detail
                                                                            .wilayah_kelurahan
                                                                            .wilayah_kecamatan.nama
                                                                    }}
                                                                </div>
                                                                <div>
                                                                    {{
                                                                        helper.detail
                                                                            .wilayah_kelurahan
                                                                            .wilayah_kecamatan
                                                                            .wilayah_kabkota.nama
                                                                    }}
                                                                </div>
                                                                <div>
                                                                    {{
                                                                        helper.detail
                                                                            .wilayah_kelurahan
                                                                            .wilayah_kecamatan
                                                                            .wilayah_kabkota
                                                                            .wilayah_provinsi.nama
                                                                    }}
                                                                </div>
                                                                <div>
                                                                    {{ helper.detail.kodepos }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-td>
                                                </b-tr>

                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No. Telepon
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.notelepon }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No. Handphone
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.nomp }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Email
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.email }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No./ Tgl. Registrasi
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.no_registrasi }}
                                                        </div>
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.tgl_registrasi }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <!--  -->
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td colspan="2" class="font-weight-bold">
                                                        <u>IDENTITAS PIMPINAN BADAN USAHA</u>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        NIK
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        <div v-if="helper.detail.pimpinan">
                                                            {{ helper.detail.pimpinan.nik }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Nama
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        <div v-if="helper.detail.pimpinan">
                                                            {{ helper.detail.pimpinan.nama }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Jabatan
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.pimpinan">
                                                            {{ helper.detail.pimpinan.jabatan }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No. Handphone
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.pimpinan">
                                                            {{ helper.detail.pimpinan.nomp }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Email
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.pimpinan">
                                                            {{ helper.detail.pimpinan.email }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Alamat
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.pimpinan">
                                                            {{ helper.detail.pimpinan.alamat }}
                                                        </div>
                                                        <div v-if="helper.detail.pimpinan">
                                                            {{ helper.detail.pimpinan.kodepos }}
                                                        </div>
                                                        <!-- {{ data.alamat }} -->
                                                        <!-- <div v-if="data.wilayah_kelurahan">
                                                            Kel. {{ data.wilayah_kelurahan.nama }}<br>
                                                            Kec. {{ data.wilayah_kelurahan.wilayah_kecamatan.nama}}<br>
                                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.nama }}<br>
                                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.wilayah_provinsi.nama }}<br>
                                                            {{ data.kodepos }}
                                                        </div> -->
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <!--  -->
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td colspan="2" class="font-weight-bold">
                                                        <u>IDENTITAS PENANGGUNG JAWAB BADAN USAHA</u>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        NIK
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        <div v-if="helper.detail.penanggung_jawab">
                                                            {{ helper.detail.penanggung_jawab.nik }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Nama
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        <div v-if="helper.detail.penanggung_jawab">
                                                            {{ helper.detail.penanggung_jawab.nama }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Jabatan
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.penanggung_jawab">
                                                            {{ helper.detail.penanggung_jawab.jabatan }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No. Handphone
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.penanggung_jawab">
                                                            {{ helper.detail.penanggung_jawab.nomp }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Email
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.penanggung_jawab">
                                                            {{ helper.detail.penanggung_jawab.email }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Alamat
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail.penanggung_jawab">
                                                            {{ helper.detail.penanggung_jawab.alamat }}
                                                        </div>
                                                        <div v-if="helper.detail.penanggung_jawab">
                                                            {{ helper.detail.penanggung_jawab.kodepos }}
                                                        </div>
                                                        <!-- {{ data.alamat }} -->
                                                        <!-- <div v-if="data.wilayah_kelurahan">
                                                            Kel. {{ data.wilayah_kelurahan.nama }}<br>
                                                            Kec. {{ data.wilayah_kelurahan.wilayah_kecamatan.nama}}<br>
                                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.nama }}<br>
                                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.wilayah_provinsi.nama }}<br>
                                                            {{ data.kodepos }}
                                                        </div> -->
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <!--  -->
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td>
                                                        <strong>Nb: </strong>
                                                        Hubungi admin Aplikasi E-BUMD apabila terdapat kesalahan data.
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                    <div class="text-center" v-else>
                        <b-spinner
                            variant="primary"
                            type="grow"
                            label="Spinning"
                        ></b-spinner>
                        <div class="font-weight-bold text-success">
                            Memuat...
                        </div>
                    </div>
                </div>
            </div>
            <!-- end of UI -->
            <!-- Administrator|Maintenance UI -->
            <div
                v-else-if="
                    ['Administrator', 'Maintenance', 'Bendahara'].includes(role)
                "
            >
                <div v-if="user.pegawai_id !== null">
                    <b-card>
                        <div v-if="detailPegawai">
                            <div class="py-3">
                                <b-table-simple small bordered>
                                    <b-tr>
                                        <b-th colspan="2">
                                            <h4 class="text-center">
                                                PROFIL SKPD, UPTD DAN IDENTITAS
                                                PENGGUNA
                                            </h4>
                                        </b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-th colspan="2">
                                            IDENTITAS SKPD/UPTD
                                        </b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-td width="200px">
                                            NAMA SKPD
                                        </b-td>
                                        <b-td>
                                            <div
                                                v-if="detailPegawai"
                                                class="font-weight-bold"
                                            >
                                                {{
                                                    detailPegawai.unit_pd
                                                        .perangkat_pd.nama
                                                }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            NAMA UPTD
                                        </b-td>
                                        <b-td>
                                            <div
                                                v-if="detailPegawai"
                                                class="font-weight-bold"
                                            >
                                                {{ detailPegawai.unit_pd.nama }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            ALAMAT
                                        </b-td>
                                        <b-td>
                                            <div v-if="detailPegawai">
                                                {{
                                                    detailPegawai.unit_pd.alamat
                                                }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                </b-table-simple>
                                <b-table-simple small bordered>
                                    <b-tr>
                                        <b-th colspan="2">
                                            IDENTITAS PENGGUNA
                                        </b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-td width="200px">
                                            NIK
                                        </b-td>
                                        <b-td>
                                            <div
                                                v-if="detailPegawai"
                                                class="font-weight-bold"
                                            >
                                                {{ detailPegawai.nik }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            NIP
                                        </b-td>
                                        <b-td>
                                            <div
                                                v-if="detailPegawai"
                                                class="font-weight-bold"
                                            >
                                                {{ detailPegawai.nip }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            NAMA
                                        </b-td>
                                        <b-td>
                                            <div
                                                v-if="detailPegawai"
                                                class="font-weight-bold"
                                            >
                                                {{ detailPegawai.nama }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            TEMPAT & TANGGAL LAHIR
                                        </b-td>
                                        <b-td>
                                            <div v-if="detailPegawai">
                                                {{ detailPegawai.tmp_lahir }},
                                                {{ detailPegawai.tgl_lahir }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            JENIS KELAMIN
                                        </b-td>
                                        <b-td>
                                            <div v-if="detailPegawai">
                                                {{
                                                    detailPegawai.jenis_kelamin
                                                }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            KONTAK
                                        </b-td>
                                        <b-td>
                                            <div v-if="detailPegawai">
                                                {{ detailPegawai.nomp }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            ALAMAT
                                        </b-td>
                                        <b-td>
                                            <div v-if="detailPegawai">
                                                {{ detailPegawai.alamat }}
                                                <div
                                                    v-if="
                                                        detailPegawai.wilayah_kelurahan
                                                    "
                                                >
                                                    <div>
                                                        Kel.
                                                        {{
                                                            detailPegawai
                                                                .wilayah_kelurahan
                                                                .nama
                                                        }}
                                                    </div>
                                                    <div>
                                                        Kec.
                                                        {{
                                                            detailPegawai
                                                                .wilayah_kelurahan
                                                                .wilayah_kecamatan
                                                                .nama
                                                        }}
                                                    </div>
                                                    <div>
                                                        {{
                                                            detailPegawai
                                                                .wilayah_kelurahan
                                                                .wilayah_kecamatan
                                                                .wilayah_kabkota
                                                                .nama
                                                        }}
                                                    </div>
                                                    <div>
                                                        {{
                                                            detailPegawai
                                                                .wilayah_kelurahan
                                                                .wilayah_kecamatan
                                                                .wilayah_kabkota
                                                                .wilayah_provinsi
                                                                .nama
                                                        }}
                                                    </div>
                                                    <div>
                                                        {{
                                                            detailPegawai.kodepos
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            EMAIL
                                        </b-td>
                                        <b-td>
                                            <div v-if="detailPegawai">
                                                {{ detailPegawai.email }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="2"></b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="2">
                                            <b class="text-danger">Catatan:</b>
                                            <em>
                                                Hubungi Admin Aplikasi apabila
                                                terdapat kesalahan data.
                                            </em>
                                        </b-td>
                                    </b-tr>
                                </b-table-simple>
                            </div>
                        </div>
                        <div class="text-center" v-else>
                            <b-spinner
                                variant="primary"
                                type="grow"
                                label="Spinning"
                            ></b-spinner>
                            <div class="font-weight-bold text-success">
                                Memuat...
                            </div>
                        </div>
                    </b-card>
                </div>
                <div v-else>
                    <b-card>
                        <h1>SELAMAT DATANG DI APLIKASI BUMD</h1>
                    </b-card>
                </div>
            </div>
            <!-- end of UI -->
        </panel>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import Vue from "vue";
import Logo from "@/assets/images/logoSumut.png";
import PageOptions from "@/config/PageOptions.vue";
import HeaderCard from "@/components/header/HeaderCard.vue";
import moment from "moment";
import pegawaiMixins from "@/helper/dashboard";
import MainContainer from "@/components/form_badan_usaha/MainContainer.vue";
import axios from "axios";
import tokenClear from "@/helper/eraseToken";

Vue.prototype.moment = moment;

export default {
    mixins: [pegawaiMixins, tokenClear],
    data() {
        return {
            imageLogo: Logo,
            user: JSON.parse(localStorage.getItem("user")),
            detailPegawai: "",
            role: JSON.parse(localStorage.getItem("roleArr"))[0],
            singleRole: ["Badan Usaha"],
            helper: {
                statReg: 5,
                daftar: false,
                verify: false,
                detail: ""
            }
        };
    },
    components: {
        HeaderCard,
        MainContainer
    },
    created() {
        PageOptions.pageEmpty = false;
        document.body.className = "";
    },
    mounted() {
        // call pegawai dari mixins
        if (this.user.pegawai_id !== null) {
            this.getDetailPegawai(this.user.pegawai_id);
        }
        if (this.singleRole.includes(this.role)) {
            // ketika role = 'Badan Usaha'
            if (this.user.npbu_id !== null) {
                this.detail(this.user.npbu_id);
                this.$store.dispatch('Npbu/getAllNpbu')
            } else {
                if (this.$route.name == "Dashboard" || this.helper.daftar) {
                    this.$router.push({ name: "Profil" });
                } else {
                    this.$router.push({ name: "Dashboard" });
                }
            }
        }
    },
    methods: {
        // data detail npbu
        async detail(npbu_id) {
            try {
                let response = await axios.get("/api/bumd/npbu/" + npbu_id);
                this.helper.detail = response.data.data;
                console.log(this.helper.detail);
                const items = response.data.data;
                if (items.status_registrasi_id == this.helper.statReg) {
                    this.helper.verify = true;
                    this.$router.push({ name: "Dashboard" });
                } else {
                    this.$router.push({ name: "Profil" });
                    localStorage.setItem("status_registrasi", false);
                }
            } catch (error) {
                console.log(error);
                if (error.response.status == 401) {
                    // mixins - tokenClear
                    this.tokenClear();
                }
            }
        }
    }
};
</script>

<style scoped>
.main:hover .cust-shadow {
    box-shadow: 3px 3px 7px black;
    transition: all 0.5s ease;
    cursor: pointer;
}
</style>
